import { api } from './api'

// The selectable chat models and the default key. Resolves to
// { models: [{ key, label }], default }.
export function listModels() {
  return api.get('/models')
}
